module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['Icons']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module Icons URL not available') },
        init: (arg) => { throw new Error('Module Icons URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['Icons'].get(request),
      init: (arg) => {
        try {
          return window['Icons'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: Icons')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module Icons not available') },
      init: (arg) => { throw new Error('Module Icons not available') }
    })
    document.head.appendChild(script);
  });